var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tabs',{attrs:{"type":"card","value":_vm.currentName},on:{"on-click":_vm.ToPage}},[_c('TabPane',{attrs:{"label":"项目阶段统计","name":"projectCount"}}),_c('TabPane',{attrs:{"label":"合同与项目统计分析","name":"contractCount"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }